import * as React from "react";
const SvgIcArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#000", d: "M14 7.333H4.553L6.94 4.94 6 4 2 8l4 4 .94-.94-2.387-2.393H14V7.333z" }));
export default SvgIcArrow;
